import { defineComponent as j, ref as S, provide as I, h as C } from "vue";
import M from "./ghl-ui.es1011.js";
import { formInjectionKey as O, formItemInstsInjectionKey as P } from "./ghl-ui.es1012.js";
import _ from "./ghl-ui.es854.js";
import x from "./ghl-ui.es855.js";
import k from "./ghl-ui.es1013.js";
import { keysOf as w } from "./ghl-ui.es924.js";
var B = globalThis && globalThis.__awaiter || function(n, c, o, r) {
  function h(f) {
    return f instanceof o ? f : new o(function(a) {
      a(f);
    });
  }
  return new (o || (o = Promise))(function(f, a) {
    function v(e) {
      try {
        t(r.next(e));
      } catch (d) {
        a(d);
      }
    }
    function i(e) {
      try {
        t(r.throw(e));
      } catch (d) {
        a(d);
      }
    }
    function t(e) {
      e.done ? f(e.value) : h(e.value).then(v, i);
    }
    t((r = r.apply(n, c || [])).next());
  });
};
const F = Object.assign(Object.assign({}, x.props), {
  inline: Boolean,
  labelWidth: [Number, String],
  labelAlign: String,
  labelPlacement: {
    type: String,
    default: "top"
  },
  model: {
    type: Object,
    default: () => {
    }
  },
  rules: Object,
  disabled: Boolean,
  size: String,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: !0
  },
  onSubmit: {
    type: Function,
    default: (n) => {
      n.preventDefault();
    }
  },
  showLabel: {
    type: Boolean,
    default: void 0
  },
  validateMessages: Object
}), q = j({
  name: "Form",
  props: F,
  setup(n) {
    const {
      mergedClsPrefixRef: c
    } = _(n);
    x("Form", "-form", M, k, n, c);
    const o = {}, r = S(void 0), h = (i) => {
      const t = r.value;
      (t === void 0 || i >= t) && (r.value = i);
    };
    function f(i, t = () => !0) {
      return B(this, void 0, void 0, function* () {
        return yield new Promise((e, d) => {
          const y = [];
          for (const u of w(o)) {
            const p = o[u];
            for (const s of p)
              s.path && y.push(s.internalValidate(null, t));
          }
          Promise.all(y).then((u) => {
            const p = u.some((l) => !l.valid), s = [], m = [];
            u.forEach((l) => {
              var g, b;
              !((g = l.errors) === null || g === void 0) && g.length && s.push(l.errors), !((b = l.warnings) === null || b === void 0) && b.length && m.push(l.warnings);
            }), i && i(s.length ? s : void 0, {
              warnings: m.length ? m : void 0
            }), p ? d(s.length ? s : void 0) : e({
              warnings: m.length ? m : void 0
            });
          });
        });
      });
    }
    function a() {
      for (const i of w(o)) {
        const t = o[i];
        for (const e of t)
          e.restoreValidation();
      }
    }
    return I(O, {
      props: n,
      maxChildLabelWidthRef: r,
      deriveMaxChildLabelWidth: h
    }), I(P, {
      formItems: o
    }), Object.assign({
      validate: f,
      restoreValidation: a
    }, {
      mergedClsPrefix: c
    });
  },
  render() {
    const {
      mergedClsPrefix: n
    } = this;
    return C("form", {
      class: [`${n}-form`, this.inline && `${n}-form--inline`],
      onSubmit: this.onSubmit
    }, this.$slots);
  }
});
export {
  q as default,
  F as formProps
};
